
    /**
     * @author tribes agency
     * @description component created by Tribes
     * ============================================================================================
     */
    export default {
        name: "TribesHeaderPage",
        props: {
            backgroundClass: {
                default: "",
                type: String
            },
            description: {
                default: "",
                type: String
            },
            image: {
                default: "",
                type: String
            },
            title: {
                default: "",
                type: String
            },
        }
    }
